import * as React from "react";
import { useId } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfo = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 192 512",
		...props,
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM0 184c0-13.3 10.7-24 24-24l64 0c17.7 0 32 14.3 32 32l0 272 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-256-48 0c-13.3 0-24-10.7-24-24z"
		})
	});
};
export default SvgInfo;
